import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ButtonLink from '../components/ButtonLink';

function About() {
    return (
        <div>
        <section className="welcome-message section-padding">
        <Container>
          <Row className="align-items-center ">
            <Col lg={6} sm={12}>
              <div className="welcome-img">
                <img src={require('../assets/img/welcome-img.jpg')} alt="Welcome img" className='img-fluid' />
                <div className='content text-right'>
                    <h4>04</h4>
                    <p>Experience</p>
                </div>
              </div>
            </Col>
            <Col lg={6} sm={12}>
            <div className="d-flex flex-column infor-di">
              
              <h2 className="title">Building a <span>Brighter Future,</span>  Together</h2>
              <p>
              We are a construction and remodeling company with a solid reputation, built on quality and the trust of our clients. Every project we undertake reflects our commitment to precision, excellence, and attention to the details that make a difference. With a highly skilled team of professionals, we are dedicated to bringing your projects to life, whether residential or commercial.
              </p>
              <h4 className="subtitle">Quality Commitment:</h4>
              <div className="welcome-list">
                  <p>Every detail matters to us, and all our work is backed by a minimum 12-month warranty at no additional cost. Our confidence in our materials and the expertise of our team allows us to offer this guarantee, ensuring long-lasting results that meet the highest industry standards.
                  </p>
              </div>
              <h4 className="subtitle">Insurance Coverage:</h4>
              <div className="welcome-list">
                  <p>We take our clients’ safety and property very seriously. Our $2,000,000 insurance coverage protects your property and investment throughout the project, providing peace of mind in the rare event of an accident.</p>
              </div>
              </div>
            </Col>
          </Row>
        </Container>
        </section>
        <section className="yellow-bg section-padding value-section">
        <Container>
          <Row>
            <Col md={12} sm={12}>
              <div className="d-flex flex-column infor-di text-center">
              
              <h2 className="title mb-4">Our Core Values </h2>
              <Row>
                <Col sm={6} md={6} lg={3} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-person-rolodex"></i></span>
                  <h4 className="subtitle">Commitment</h4>
                  <p>Complete dedication to client satisfaction and excellence in every project.</p>
                  </div>
                </Col>

                <Col sm={6} md={6} lg={3} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-hand-thumbs-up"></i></span>
                  <h4 className="subtitle">Quality</h4>
                  <p>We ensure the use of top-quality materials and modern construction techniques.</p>
                  </div>
                </Col>

                <Col sm={6} md={6} lg={3} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-transparency"></i></span>
                  <h4 className="subtitle">Transparency</h4>
                  <p>We communicate every project detail clearly and openly, fostering a relationship of trust.</p>
                  </div>
                </Col>

                <Col sm={6} md={6} lg={3} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-safe"></i></span>
                  <h4 className="subtitle">Safety</h4>
                  <p>We adhere to all safety standards to protect our team and our clients’ property.</p>
                  </div>
                </Col>

                
              </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="section-padding">
        <Container>
            <Row>
                <Col>
                <div className="d-flex align-items-center justify-content-between py-3 title-box">
                  <h2 className="col-lg-7 title"><span>Let us be part of your projects. 
                  Your vision is our mission.</span></h2>
                  <ButtonLink link="/contact" name="Explore More" />
                </div>
                    
                </Col>
            </Row>
        </Container>
     </section>
    </div>
    );
}

export default About;
